import { FunctionComponent as F, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../core/store/hooks";
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import IconButton from "@mui/material/IconButton";
import Button from "../UI/Button/Button";
import { validatePrice, validateProtocolOrFolderName } from "../../utils/validate";
import { submitNewProtocolAsync } from "../../core/store/protocol/protocol.thunks";
import { PROTOCOL } from "../../core/router/paths";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { useSelector } from "react-redux";
import { IState } from "../../core/store/store";


interface Props
{
  folderId?: number,
  close: () => void,
  open: boolean
}

const NewProtocolDialog: F<Props> = (props: Props) =>
{
  const navigate = useNavigate();
  const appDispatch = useAppDispatch();

  const [name, setName] = useState("My Protocol");
  const [budget, setBudget] = useState("");

  const currencySymbol = useSelector((state: IState) => state.user.currencySymbol);

  const handleSubmit = () =>
  {
    if(!validateProtocolOrFolderName(name))
      return;

    appDispatch(submitNewProtocolAsync(name, props.folderId, budget ? Number(budget) : undefined))
      .then(protocolId => navigate(PROTOCOL + "/" + protocolId));

    props.close()
  };


  return (
    <Dialog
      maxWidth='md'
      fullWidth
      PaperProps={{ sx: { p: '15px' }}}
      open={props.open}
      onClose={props.close}>

      <IconButton
        disableRipple
        onClick={() => navigate("../", { relative: 'path' })}
        sx={{ display: 'inline-flex', float: 'left', width: '80px' }}>
        <ArrowBackIosNewIcon sx={{ mt: 3, ml: 1, fontSize: 65, color: 'lightGray' }}/>
      </IconButton>

      <DialogTitle sx={{ ml: 3, fontSize: '30px' }}>Add a new protocol</DialogTitle>

      <DialogContent>
        <Stack spacing={2} sx={{ width: '750px', pt: 1 }}>
          <TextField
            label='Protocol Name'
            variant='outlined'
            size='small'
            sx={{ width: '750px' }}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => setName(event.target.value)}
            error={!validateProtocolOrFolderName(name)} />
          <FormControl>
            <InputLabel htmlFor='outlined-adornment-amount'>
              Budget
            </InputLabel>
            <OutlinedInput
              size='small'
              sx={{ pt: '6px' }}
              startAdornment={
                <InputAdornment position='start'>
                  {currencySymbol}
                </InputAdornment>}
              label='Budget'
              value={budget}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => setBudget(event.target.value)}
              error={Boolean(budget) && !validatePrice(budget)}/>
          </FormControl>
          <Button
            label='Submit'
            onClick={handleSubmit}/>
        </Stack>
      </DialogContent>

    </Dialog>);
};


export default NewProtocolDialog;
